// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rec-spinner-container[data-v-1930fba4]{display:flex;align-items:center;justify-content:center}.rec-spinner-container .rc-loader[data-v-1930fba4]{margin:0}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
